/**
 * Canales que carga PodTube. Este fichero manda: añadir o quitar un canal aquí se refleja al
 * recargar. Desde la app solo se puede pausar un canal o cambiar sus límites, y ese cambio se
 * guarda en el navegador por encima de lo que diga este fichero.
 *
 * minDuration / maxDuration: límites en minutos para los episodios de ese canal (null = sin
 * límite). Para un podcast RSS o Substack, el id es "rss:<url del feed>" y se añade
 * type: "rss" | "substack" y feedUrl.
 */
export const CHANNELS = [
  {
    id: "UCAAGdEk4YbbkTJZ0IqaAljA",
    title: "Kaizen",
    host: "Jaime Rodríguez de Santiago",
    handle: "@jaimerodriguezdesantiago",
    avatar:
      "https://yt3.googleusercontent.com/ytc/AIdro_mLVsRGIT7Abk5oo6AC41f3tYv-3l_BtZkbv02qzQUiAg=s176-c-k-c0x00ffffff-no-rj",
    color: "#3b82f6",
    minDuration: null,
    maxDuration: null,
  },
  {
    id: "UCJFP-5V2-0BFeVmKifG0H_Q",
    title: "Tengo un Plan",
    host: "Juan Domínguez & Sergio Beguería",
    handle: "@TengoUnPlanPodcast",
    avatar:
      "https://yt3.googleusercontent.com/UwVlpCqELis9j-0NVXfLVfSqQMMo4hzxV3HueAXoCo4BnPTL9BlK2TjxWB8yfDEEgViUA62c=s176-c-k-c0x00ffffff-no-rj",
    color: "#10b981",
    minDuration: 50,
    maxDuration: null,
  },
  {
    id: "UCWU8fcAN3X8hjMR9k0rbV5g",
    title: "Nadie Sabe Nada",
    host: "Andreu Buenafuente & Berto Romero",
    handle: "@NadieSabeNada",
    avatar:
      "https://yt3.googleusercontent.com/BfZFTsxcQUicTpp0p9Qdis2h-JFOoONZovYC1jHsWYKxFCkQxq3fJucvTajWA440pK2o_H9uAg=s176-c-k-c0x00ffffff-no-rj",
    color: "#f59e0b",
    minDuration: 30,
    maxDuration: null,
  },
  {
    id: "UCUWDBUEo1YFTzZnBV1aFDBw",
    title: "spicy4tuna",
    handle: "@spicy4tuna",
    avatar:
      "https://yt3.googleusercontent.com/B7_wYBlSHXJoKpJ1TSgES28NmydA0rb58rpNNM2Er7OucmC8hMLkNSgHFkQToM38HsJa_lzkvVc=s176-c-k-c0x00ffffff-no-rj",
    color: "#ef4444",
    minDuration: 60,
    maxDuration: null,
  },
  {
    id: "UCDe9LvD14Fip9ncPvkcQgxg",
    title: "Fitness Revolucionario",
    handle: "@Fitnessrevolucionario",
    avatar:
      "https://yt3.googleusercontent.com/ETuUly2sDNqCBJi5-WCwEBYt_fmxw_ecKP7ItdfuQqETqgYbMzv6ZKU4gbcbvbsH9-CqOCCAOWA=s176-c-k-c0x00ffffff-no-rj",
    color: "#84cc16",
    minDuration: null,
    maxDuration: null,
  },
  {
    id: "UCDwflVe6kxtJTDdF8CPs6jw",
    title: "Fabián C. Barrio",
    handle: "@fabiancbarrio",
    avatar:
      "https://yt3.googleusercontent.com/ytc/AIdro_lHD4i0MLUc8Pq2Psdx-mbaRJbWqaI67pbJ4ij25QNsK3s=s176-c-k-c0x00ffffff-no-rj",
    color: "#06b6d4",
    minDuration: null,
    maxDuration: null,
  },
  {
    id: "UCyYkUq0qMNP-ea7LEvspkug",
    title: "Los Ecomonos",
    handle: "@ecomonos",
    avatar:
      "https://yt3.googleusercontent.com/RahmiRQ0LVoUuScxueHEhuZT0m05BrZeMdYQIaF9zM8TPZPxfv8S9K93F1HHydtlZP_cxW9tBlY=s176-c-k-c0x00ffffff-no-rj",
    color: "#8b5cf6",
    minDuration: null,
    maxDuration: null,
  },
  {
    id: "UCpIkcITpCk_rV1nhYeGNHNQ",
    title: "Mago More",
    handle: "@lashistoriasdelmagomore",
    avatar:
      "https://yt3.googleusercontent.com/MB7BO4sdKi_Io_BEjWbJRsEd3K6rRP5m1T-_0RoLHGmnYX2GDM-DLuqK9u3UeM94Ts9ICAgp=s176-c-k-c0x00ffffff-no-rj",
    color: "#ec4899",
    minDuration: null,
    maxDuration: null,
  },
  {
    id: "UCWNhbffgSpY-6Z4DCBdxqVg",
    title: "Nada Que Ganar",
    handle: "@nadaqueganar",
    avatar:
      "https://yt3.googleusercontent.com/vBmTeBT6-hr3hl5vriEESIMcST4nguOHxypOKJX_boDlmgPPJguE2BA5g2oRxgDo7ByO96JYaVU=s176-c-k-c0x00ffffff-no-rj",
    color: "#14b8a6",
    minDuration: null,
    maxDuration: null,
  },
];
